import api from './index'

const resource = '/environment'

export default {
  getEnv () {
    return api.get(`${resource}`)
  }
}
